// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import pixIconSrc from './pix-icon.svg';

export function DisplayPixBrand(): Node {
  return (
    <Root>
      <PixIconWrapper>
        <PixIcon src={pixIconSrc} alt="pix" />
      </PixIconWrapper>
    </Root>
  );
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const PixIconWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;

const PixIcon = styled.img`
  width: 32px;
  height: 24px;
`;
